import { render, staticRenderFns } from "./headsale.vue?vue&type=template&id=32f9768d&scoped=true&"
import script from "./headsale.vue?vue&type=script&lang=js&"
export * from "./headsale.vue?vue&type=script&lang=js&"
import style0 from "./headsale.vue?vue&type=style&index=0&id=32f9768d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9768d",
  null
  
)

export default component.exports